var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.89813L15.5303 8.42846L16.0607 7.89813L15.5303 7.3678L15 7.89813ZM11.7719 15.75C12.1861 15.75 12.5219 15.4142 12.5219 15C12.5219 14.5858 12.1861 14.25 11.7719 14.25L11.7719 15.75ZM11.7719 11.1262L12.3022 11.6566L15.5303 8.42846L15 7.89813L14.4697 7.36779L11.2415 10.5959L11.7719 11.1262ZM15 7.89813L15.5303 7.3678L12.3022 4.13967L11.7719 4.67L11.2415 5.20033L14.4697 8.42846L15 7.89813ZM15 7.89813L15 7.14813L8.22094 7.14812L8.22094 7.89812L8.22094 8.64812L15 8.64813L15 7.89813ZM8.22094 15L8.22094 15.75L11.7719 15.75L11.7719 15L11.7719 14.25L8.22094 14.25L8.22094 15ZM4.67 11.4491L3.92 11.4491C3.92 13.8244 5.84559 15.75 8.22094 15.75L8.22094 15L8.22094 14.25C6.67402 14.25 5.42 12.996 5.42 11.4491L4.67 11.4491ZM8.22094 7.89812L8.22094 7.14812C5.8456 7.14812 3.92 9.07372 3.92 11.4491L4.67 11.4491L5.42 11.4491C5.42 9.90215 6.67402 8.64812 8.22094 8.64812L8.22094 7.89812Z",
    fill: "#33363F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/Next.5691272f0e02f53ffe67627344505ffe.svg";
export { ForwardRef as ReactComponent };